module.exports = __webpack_public_path__ + "img/vertical_3_7_8019.f483527b.png";